import React from "react";
import EmployeeStatus from "components/Tvendo/Distribution/DataMaster/EmployeeStatus/List";

export default function () {
  return <EmployeeStatus />;
}
